<template>
  <div class="status-badge" :class="statusClass">
    {{ statusText }}
  </div>
</template>

<script>
import WithdrawalStatus from "@views/withdrawals/new/enums/withdrawalStatus";

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
      validator: value => Object.values(WithdrawalStatus).includes(value)
    }
  },
  computed: {
    statusText() {
      return WithdrawalStatus.getLabel(this.status)
    },
    statusClass() {
      const classMap = {
        [WithdrawalStatus.ANALYZE]: 'status-em-andamento',
        [WithdrawalStatus.BEING_WORKED_ON]: 'status-em-andamento',
        [WithdrawalStatus.PROCESSING]: 'status-processando-dados',
        [WithdrawalStatus.ACCEPTED]: 'status-saque-transferido',
        [WithdrawalStatus.DENIED]: 'status-saque-recusado',
        [WithdrawalStatus.REQUESTED]: 'status-saque-nao-analisado',
        [WithdrawalStatus.APPROVED]:'status-saque-analisado'
      }
      return classMap[this.status] || ''
    }
  }
}
</script>

<style scoped>
.status-badge {
  display: flex;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 500px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.status-em-andamento, .status-processando-dados{
  background: var(--Blue-50, #EFF6FF);
  color: var(--Blue-700, #1A52DB);
}

.status-saque-transferido, .status-saque-analisado {
  background: var(--Primary-50, #EBFEF6);
  color: var(--Primary-700, #007C5D);
}

.status-saque-recusado {
  background: var(--Red-50, #FFF3ED);
  color: var(--Red-700, #C71307);
}

.status-saque-nao-analisado {
  background: var(--Yellow-50, #FEFCE8);
  color: var(--Yellow-700, #9E610A);
}
</style>
